import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import handleValidDate from "../../../helpers/utils/handleValidDate";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetPositionState, getPosition } from "../../../store/position/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { resetReimbursementTypeState, getReimbursementType as onGetReimbursementTypes, addNewReimbursementType as onAddNewReimbursementType, updateReimbursementType as onUpdateReimbursementType, deleteReimbursementType as onDeleteReimbursementType, getReimbursementTypeLoading } from "../../../store/reimbursementType/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const ReimbursementType = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [pageIdx, setPageIdx] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, reimbursementTypes, isReimbursementTypeCreated, isReimbursementTypeSuccess, loading, error, companies, companyLoading, clientLoading, clients, positions, positionLoading, accAccounts, accAccountLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    reimbursementTypes: state.ReimbursementType.reimbursementTypes,
    isReimbursementTypeCreated: state.ReimbursementType.isReimbursementTypeCreated,
    isReimbursementTypeSuccess: state.ReimbursementType.isReimbursementTypeSuccess,
    loading: state.ReimbursementType.loading,
    error: state.ReimbursementType.error,
    positions: state.Position.positions,
    positionLoading: state.Position.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clientLoading: state.Client.loading,
    clients: state.Client.clients,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [reimbursementTypeList, setReimbursementTypeList] = useState([]);
  const [reimbursementTypeDoc, setReimbursementTypeDoc] = useState([]);
  const [reimbursementType, setReimbursementType] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  useEffect(() => {
    dispatch(resetReimbursementTypeState());
    dispatch(onGetReimbursementTypes({ companyId: companySelected.value }));
    handleGetAccAccount(companySelected.value);
  }, [companySelected]);

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  const onClickDelete = (reimbursementType) => {
    setReimbursementType(reimbursementType);
    setDeleteModal(true);
  };

  const handleDeleteReimbursementType = () => {
    if (reimbursementType) {
      dispatch(onDeleteReimbursementType(reimbursementType));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(reimbursementTypes)) {
      let filteredReimbursementTypes = reimbursementTypes;
      if (activeTypeTab !== "all") {
        filteredReimbursementTypes = reimbursementTypes.filter((reimbursementType) => reimbursementType.loan_term_status.name === activeTypeTab);
      }
      setReimbursementTypeList(filteredReimbursementTypes.map((el) => ({ ...el, isChecked: false })));
    }
  }, [reimbursementTypes]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "startat",
        label: "Tanggal Berlaku",
        isSelected: true,
        data: [],
      },
      {
        id: "reimbursement_type_acc_account",
        label: "Akun",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "reimbursement_type_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "reimbursement_type_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (reimbursementTypeList.length > 0) {
      reimbursementTypeList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "reimbursement_type_client" || doc.id === "reimbursement_type_company" || doc.id === "reimbursement_type_acc_account") {
                doc.data.push(value?.name ?? "");
              } else if (doc.id === "startat") {
                doc.data.push(value !== null ? handleValidDate(value) : "-");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setReimbursementTypeDoc(dataDoc);
  }, [reimbursementTypeList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredReimbursementTypes = reimbursementTypes;
      if (type !== "all") {
        filteredReimbursementTypes = reimbursementTypes.filter((reimbursementType) => reimbursementType.loan_term_status.name === type);
      }
      setReimbursementTypeList(filteredReimbursementTypes);
    }
  };

  useEffect(() => {
    setReimbursementType(reimbursementTypes);
  }, [reimbursementTypes]);

  useEffect(() => {
    if (!isEmpty(reimbursementTypes)) {
      setReimbursementType(reimbursementTypes);
      setIsEdit(false);
    }
  }, [reimbursementTypes]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setReimbursementType(null);
    } else {
      setModal(true);
    }
  }, [modal, dispatch]);

  const handleReimbursementTypeClick = useCallback(
    (arg) => {
      const data = arg;
      setReimbursementType({
        id: data.id,
        description: data.description,
        startat: data.startat,
        name: data.name,
        account: data.reimbursement_type_acc_account && {
          label: data.reimbursement_type_acc_account.name,
          value: data.reimbursement_type_acc_account.id,
        },
        client: {
          label: data.reimbursement_type_client.name,
          value: data.reimbursement_type_client.id,
        },
        company: {
          label: data.reimbursement_type_company.name,
          value: data.reimbursement_type_company.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteReimbursementType(element.value));
    });
    checkall.checked = false;
  };

  const handleApproveReimbursement = () => {
    if (reimbursementType) {
      reimbursementType.setApprove = true;
      dispatch(onUpdateReimbursementType(reimbursementType));
      dispatch(resetReimbursementTypeState());
      dispatch(onGetReimbursementTypes({ companyId: companySelected.value }));
      setApproveModal(false);
    }
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = reimbursementTypeList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setReimbursementTypeList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = reimbursementTypeList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setReimbursementTypeList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateReimbursementType") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleReimbursementTypeClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteReimbursementType") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      data.statusId = 3;
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
              {data.statusId === 1 && (
                <button
                  className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : userRole && userRole.split(",").indexOf("approveReimbursementType") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-1" : "btn-label btn btn-sm btn-soft-success fs-12 ms-1 d-none"}
                  onClick={() => {
                    data.statusId = 2;
                    setReimbursementType(data);
                    setApproveModal(true);
                  }}
                >
                  <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i> Approve
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Akun",
        accessor: "reimbursement_type_acc_account.name",
        filterable: true,
        Cell: (cell) => {
          return (
            <span>
              {cell.row.original.reimbursement_type_acc_account && cell.row.original.reimbursement_type_acc_account.code} - {cell.row.original.reimbursement_type_acc_account && cell.row.original.reimbursement_type_acc_account.name}
            </span>
          );
        },
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Tanggal",
        accessor: "startat",
        filterable: true,
        Cell: (interest) => <> {handleValidDate(interest.row.original.startat)} </>,
      },
      {
        Header: "Status",
        accessor: "loan_term_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [reimbursementTypeList, handleReimbursementTypeClick, userType, userRole, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = reimbursementTypeList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setReimbursementTypeList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => reimbursementTypeList, [reimbursementTypeList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: (reimbursementType && reimbursementType.name) ?? "",
      startat: reimbursementType && reimbursementType.startat,
      interest: (reimbursementType && reimbursementType.interest) || 0,
      interest_type: (reimbursementType && reimbursementType.interest_type) || "Flat",
      period: reimbursementType && reimbursementType.period,
      amount: reimbursementType && reimbursementType.amount,
      description: (reimbursementType && reimbursementType.description) ?? "",
      position: reimbursementType && reimbursementType.position,
      client: (reimbursementType && reimbursementType.client) || clientSelected,
      company: (reimbursementType && reimbursementType.company) || companySelected,
      account: (reimbursementType && reimbursementType.account) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Pick Term Name"),
      interest: Yup.string().required("Please Enter Rate"),
      startat: Yup.string().required("Please Pick Effective Date"),
      account: Yup.object().required("Please enter reimbursement account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getReimbursementTypeLoading());
      if (isEdit) {
        const updateReimbursementType = {
          id: reimbursementType ? reimbursementType.id : 0,
          statusId: 1,
          description: values.description,
          name: values.name,
          startat: values.startat,
          clientId: values.client.value,
          companyId: values.company.value,
          accId: values.account.value,
        };
        dispatch(onUpdateReimbursementType(updateReimbursementType));
        validation.resetForm();
      } else {
        const newReimbursementType = {
          statusId: 1,
          description: values.description,
          name: values.name,
          startat: values.startat,
          clientId: values.client.value,
          companyId: values.company.value,
          accId: values.account.value,
        };
        dispatch(onAddNewReimbursementType(newReimbursementType));
        validation.resetForm();
      }
      toggle();
    },
  });

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var name = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      name: name,
    };
    dispatch(onGetReimbursementTypes(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setSearchValue("");
    setStatusActive([]);
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetReimbursementTypeState());
    dispatch(onGetReimbursementTypes({ companyId: companySelected.value }));
    handleGetAccAccount(companySelected.value);
  };

  document.title = "ReimbursementTypes | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={reimbursementTypeList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteReimbursementType} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={reimbursementType && reimbursementType.loan_term_employee ? reimbursementType.loan_term_employee.name + " - " + reimbursementType.interest : ""} show={approveModal} onApproveClick={handleApproveReimbursement} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Reimbursement" pageTitle="Keuangan" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createReimbursementType") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setReimbursementType("");
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={reimbursementTypeDoc} />
            <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn ms-1 btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteReimbursementType") !== -1 ? "btn ms-1 btn-soft-danger" : "btn ms-1 btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button>
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="reimbursementTypeList">
              <CardBody className="pt-1">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-wallet-3-line me-1 align-bottom fs-14"></i> All Reimbursement
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count}  Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={3} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3} className="col-xxl-2">
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"
                              ></Select>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div>
                              <button
                                type="button"
                                className="btn btn-light w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {" "}
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {" "}
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Reimbursement" : "Add Reimbursement"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;
                            {clientLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              dispatch(setClientSelect(e));
                              validation.setFieldValue("client", e);
                            }}
                            options={clientList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;
                            {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              dispatch(setCompanySelect(e));
                              validation.setFieldValue("company", e);
                            }}
                            options={companyList}
                          ></Select>
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="name-field" className="form-label">
                            Nama
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Reimbursement" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 ">
                          <Label htmlFor="date-field" className="form-label">
                            Tanggal Berlaku
                          </Label>
                          <Flatpickr
                            name="startat"
                            className="form-control"
                            placeholder="Pilih Tanggal"
                            options={{ enableTime: false, dateFormat: "Y/m/d" }}
                            value={validation.values.startat ?? ""}
                            onChange={(o, e) => {
                              validation.setFieldValue("startat", e);
                            }}
                          />
                          {validation.touched.startat && validation.errors.startat ? (
                            <p className="text-danger" type="invalid">
                              {validation.errors.startat}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <label className="form-label" htmlFor="account">
                            Akun Reimbursement
                          </label>
                          <Select
                            name="account"
                            value={validation.values.account}
                            placeholder="Enter account"
                            onChange={(e) => {
                              validation.setFieldValue("account", e);
                            }}
                            options={accountingList}
                          ></Select>
                          {validation.touched.account && validation.errors.account && (
                            <small className="text-danger" type="invalid">
                              {validation.errors.account}
                            </small>
                          )}
                        </div>
                        <div className="mb-4">
                          <Label htmlFor="description-field" className="form-label">
                            Keterangan
                          </Label>
                          <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Close
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah Reimbursement"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0" role="name">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ReimbursementType;
